import { Api } from "../config/request";

export default {
  getDriverSheltersList(payload) {
    return Api.post(`/list_shelters`, payload);
  },
  getDriverShelter(id) {
    return Api.get(`/shelter/${id}`);
  },
  createShelter(payload) {
    return Api.post(`/shelter`, payload);
  },
  updateShelter(payload) {
    return Api.put(`/shelter`, payload);
  },
};
